import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const negatives = ['This is not a random collection of Weightlifting drills.', 'This is not a generic strength manual filled with theory you still need to turn into a real session.', 'This is not a text-heavy technical ebook.', 'This is not an app or a video course.'];
const systemContents = ['Visual lift sequences', 'Bar-path diagrams', 'Correct vs Incorrect comparisons', 'Athlete-position maps', 'Step-by-step progressions', 'Foot-position diagrams', 'Technical error breakdowns', 'Visual correction systems', 'Drill cards', 'Coaching cue cards', 'Technical checklists', 'Assessment sheets', 'Progression ladders', 'Quick-reference field cards'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-blue-950 relative overflow-hidden" data-id="element-256" data-mp="2jfwtel11o3mq">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-px bg-amber-500/60" data-id="element-257" data-mp="2fg5vzyh0ip98" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-258" data-mp="2bwicj3e4ycad">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-259" data-mp="2bxti98r55u44">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-white/10 text-amber-500 mb-5" data-id="element-260" data-mp="2pv88ugt4s7xo">
            <span className="text-2xl" data-id="element-261" data-mp="1t60mx7olnwt8">🏆</span>
          </div>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 text-white" data-id="element-262" data-mp="1t3ehpep6lte6">
            The complete 6-in-1 visual Olympic Weightlifting coaching system for coaches worldwide
          </h2>
          <h3 className="text-xl font-serif font-bold text-amber-500 mb-3" data-id="element-263" data-mp="2242wibmefxs4">
            OLYMPIC WEIGHTLIFTING COACH READY
          </h3>
          <p className="text-base md:text-lg text-white/80 mb-10" data-id="element-264" data-mp="19i078of9ou4e">
            6 Complete Visual Coaching Systems • 150 Ready-to-Coach Sessions • 5 Professional Bonus
            Guides
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-265" data-mp="2hpxokyhxjyr9">
          <motion.div initial={{
          opacity: 0,
          x: -12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="space-y-3 bg-white/5 p-6 rounded-2xl border border-white/15" data-id="element-266" data-mp="2csnsx13y6quz">
            {negatives.map(statement => <div key={statement} className="flex items-start gap-3" data-id="element-267" data-mp="1yuh5yg0jeba3">
                <X className="text-red-400 shrink-0 mt-1" size={18} data-id="element-268" data-mp="1tuupzytbqgxl" />
                <p className="text-white/70 text-sm" data-id="element-269" data-mp="27tb6uikwhntg">{statement}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 12
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-white p-6 rounded-2xl border border-amber-500" data-id="element-270" data-mp="22t6r4urtgx4a">
            <div className="flex items-start gap-3" data-id="element-271" data-mp="3moklhrobe9kc">
              <Check className="text-amber-500 shrink-0 mt-1" size={20} data-id="element-272" data-mp="3qrh59lplcbpv" />
              <p className="text-blue-950 font-medium text-base leading-relaxed" data-id="element-273" data-mp="3qpe9el1rbod8">
                Olympic Weightlifting Coach Ready is a complete PDF-based 6-in-1 Visual Coaching
                System created to help coaches plan less, teach with more structure, visually
                explain technical positions, identify errors faster and develop athletes from
                beginner to advanced.
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-6 bg-white/5 p-6 rounded-2xl border border-white/15 text-left" data-id="element-274" data-mp="3vqk1qhri99m8">
          <p className="text-white font-semibold mb-4" data-id="element-275" data-mp="x2wo47oyrzz5">Throughout the system, you&apos;ll find:</p>
          <ul className="grid sm:grid-cols-2 gap-x-6 gap-y-2.5" data-id="element-276" data-mp="34iae93adk1qx">
            {systemContents.map(item => <li key={item} className="flex items-start gap-2 text-sm text-white/80" data-id="element-277" data-mp="30l5zpcioopay">
                <Check size={16} className="text-amber-500 shrink-0 mt-0.5" data-id="element-278" data-mp="2vlt1xwq9xxtl" />
                <span data-id="element-279" data-mp="2qm6obm6jafk9">{item}</span>
              </li>)}
          </ul>
        </motion.div>

        <p className="text-amber-500 font-bold text-base md:text-lg mt-8" data-id="element-280" data-mp="3o7umocmjv7yf">
          Open the system. Choose the objective. See the technique. Select the progression. Coach.
        </p>
      </div>
    </section>;
}